import { FC, SVGProps } from 'react'

export const ThumbsUpIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    {...props}
  >
    <path
      d="M4.66659 7.33334L7.33325 1.33334C7.86369 1.33334 8.37239 1.54406 8.74747 1.91913C9.12254 2.2942 9.33325 2.80291 9.33325 3.33334V6.00001H13.1066C13.2999 5.99782 13.4913 6.03768 13.6676 6.11682C13.844 6.19596 14.001 6.3125 14.1278 6.45835C14.2547 6.60421 14.3483 6.77589 14.4021 6.96151C14.456 7.14713 14.4689 7.34225 14.4399 7.53334L13.5199 13.5333C13.4717 13.8513 13.3102 14.1411 13.0652 14.3493C12.8202 14.5576 12.5081 14.6703 12.1866 14.6667H4.66659M4.66659 7.33334V14.6667M4.66659 7.33334H2.66659C2.31296 7.33334 1.97382 7.47382 1.72378 7.72387C1.47373 7.97392 1.33325 8.31305 1.33325 8.66668V13.3333C1.33325 13.687 1.47373 14.0261 1.72378 14.2762C1.97382 14.5262 2.31296 14.6667 2.66659 14.6667H4.66659"
      stroke="currentColor"
      strokeOpacity="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
